bq.recommendations = bq.recommendations || {};

bq.recommendations.escapeHtmlAttr = function(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};

bq.recommendations.buildImageHtml = function(imageUrl, supplierId, supplierImageBaseUrl, defaultSupplierImageUrl, size) {
    var esc = bq.recommendations.escapeHtmlAttr;
    var parsedSupplierId = parseInt(supplierId, 10);
    var supplierFallback = parsedSupplierId ? (supplierImageBaseUrl + parsedSupplierId + '.jpg') : defaultSupplierImageUrl;
    var resolvedImageUrl = imageUrl ? String(imageUrl) : supplierFallback;
    return '<img src="' + esc(resolvedImageUrl) + '" alt="" class="rec-img rec-img--' + parseInt(size, 10) + '"' +
        ' data-fallback-state="primary"' +
        ' data-supplier-fallback="' + esc(supplierFallback) + '"' +
        ' data-default-fallback="' + esc(defaultSupplierImageUrl) + '"' +
        ' onerror="bqHandleRecommendationImageError(this)" />';
};

if (typeof window.bqHandleRecommendationImageError !== 'function') {
    window.bqHandleRecommendationImageError = function(img) {
        if (!img) { return; }
        var state = img.getAttribute('data-fallback-state');
        var supplierFallback = img.getAttribute('data-supplier-fallback') || '';
        var defaultFallback = img.getAttribute('data-default-fallback') || '';
        if (state !== 'supplier' && supplierFallback) {
            img.setAttribute('data-fallback-state', 'supplier');
            img.src = supplierFallback;
            return;
        }
        if (state !== 'default' && defaultFallback) {
            img.setAttribute('data-fallback-state', 'default');
            img.src = defaultFallback;
            return;
        }
        img.onerror = null;
    };
}
